// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/program-banner-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KnowledgeCenter_banner__3hxD0 {
    display: flex;
    justify-content: space-between;
    align-items: end;
    background-image: none;
    position: relative;
    z-index: -1;
}
.KnowledgeCenter_container__-5HE6{
    font-family: 'Aktiv Grotesk', sans-serif;
    margin: 50px 0px;
}
.KnowledgeCenter_bannerText__8qlXG {
    padding: 0 0 0 5%;
    min-width: 400px;
}
.KnowledgeCenter_bannerTitle__oYdm3 {
    font-size: 60px;
    font-family: 'Cocon Bold', sans-serif;
    padding-bottom: 10px;
}
.KnowledgeCenter_buttons__YR49s {
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    align-items: center;
    justify-content: space-evenly;
}
.KnowledgeCenter_inactiveButton__m5hex {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30%;
    z-index: 1;
    height: 67px;
    background: transparent;
    color: rgb(0, 0, 0);
    border-top: 2px solid;
    border-right: 2px solid;
    border-left: 2px solid;
    border-bottom: none;
    border-top-left-radius: 2em;
    border-top-right-radius: 2em;
}
.KnowledgeCenter_activeButton__Xpz7p {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30%;
    z-index: 1;
    height: 85px;
    color: #fff;
    background: #69bf4a;
    border: 2px solid transparent;
    border-top-left-radius: 2em;
    border-top-right-radius: 2em;
}
.KnowledgeCenter_buttonText__QkJ-e {
    font-weight: 800;
    font-size: 30px;
}
.KnowledgeCenter_webBanner__7YbjW {
    position: relative;
    right: 0;
    width: 60%;
}
.KnowledgeCenter_divider__OvsQD {
    height: 22px;
    width: 90%;
    margin-left: 90px;
    margin-right: 90px;
    background-color: #69bf4a;
    position: absolute;
    bottom: -11px;
    border-radius: 999px;
}
.KnowledgeCenter_buttonArrow__goD3O {
    position: absolute;
    bottom: -30px;
    height: 60px;
    z-index: -1;
}

.KnowledgeCenter_secondDivider__D3-z5 {
    height: 11px;
    position: relative;
    top: -10px;
    margin: 0 auto;
    display: block;
    width: 77%;

}

.KnowledgeCenter_safetyTitle__aAr\\+9 {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    color: #69bf4a;
    font-weight: 800;
    font-size: 50px;
    margin: 1em auto;
}
.KnowledgeCenter_safetyTitle__aAr\\+9 img {
    margin-right: 0.5em;
}
.KnowledgeCenter_safetySection__KX4p5 {
    margin: 0 5rem;
    text-align: center;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.KnowledgeCenter_safetyItem__cZKSg {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: calc(50% - 10px);
    margin-bottom: 20px;
    gap: 10px;
}
.KnowledgeCenter_safetyItem__cZKSg div {
    font-size: 24px;
    font-weight: 700;
    text-align: left;
}
.KnowledgeCenter_safetyItem__cZKSg img {
    height: 51px;
}
.KnowledgeCenter_lastItem__qUC9E {
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 3em;
}
.KnowledgeCenter_safetyButtons__9opkc {
    margin: 5rem;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.KnowledgeCenter_safetyButtons__9opkc a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(50% - 2em);
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 700;
    background-color: #13bfb9;
    color: #fff;
    border-radius: 999px;
    text-decoration: none;
    padding: 0.5em;
}
.KnowledgeCenter_safetyButtons__9opkc a:hover {
    background-color: #69bf4a;
}


.KnowledgeCenter_mythVsReality__ESCgl {
    display: flex;
    gap: 11px;
    flex-direction: column;
}
.KnowledgeCenter_realityTitle__-jMYA {
    color: #69bf4a;
    font-weight: 800;
    font-size: 50px;
    text-align: center;
}
.KnowledgeCenter_closedBox__H0XA1 {
    border: 1px solid #69bf4a;
    width: 60%;
    border-radius: 14px;
    margin: 0 auto;
}
.KnowledgeCenter_openBox__4MX22 {
    border: 1px solid #000;
    width: 60%;
    border-radius: 14px;
    margin: 0 auto;
}
.KnowledgeCenter_openHeader__skNOu {
    background-color: #69bf4a;
    border-radius: 13px;
    font-size: 24px;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.KnowledgeCenter_openHeaderText__faTyb {
    color: #000;
    font-weight: 700;
}
.KnowledgeCenter_openHeaderMyth__\\+byQP {
    margin: 0;
    color: #fff;
    font-weight: 700;
}
.KnowledgeCenter_closedHeader__3ycxb {
    background-color: #fff;
    border-radius: 13px;
    font-size: 24px;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #000;
}
.KnowledgeCenter_closedHeaderText__sKIGd {
    color: #000;
    font-weight: 700;
}
.KnowledgeCenter_closedHeaderMyth__Nz27- {
    color: #13bfb9;
    font-weight: 700;
}
.KnowledgeCenter_questionBody__0gOf7 {
    padding: 22px;
    margin: 0;
    font-size: 18px;
    line-height: 1.5;
    letter-spacing: 1px;
}

.KnowledgeCenter_glpVsObesity__OwRPU {
    margin: 0 auto;
    width: 80%;
}
.KnowledgeCenter_glp1s__1vIMw {
    color: #69bf4a;
}
.KnowledgeCenter_obesity__J\\+Ht3 {
    color: #13bfb9;
}
.KnowledgeCenter_glpVsObesityTitle__Py3ze {
    color: #000;
    font-weight: 800;
    font-size: 50px;
    text-align: center;
    margin: 40px 0 0;
}
.KnowledgeCenter_glpVsObesityHeader__WZHsH {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
}
.KnowledgeCenter_glpVsObesitySection__vpFBi {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 2em;
    gap: 11px;
}

.KnowledgeCenter_glpSection__X1ghI {
    border: 1px solid #69bf4a;
    border-radius: 14px;
    width: 45%;
}

.KnowledgeCenter_glpHeader__XhZLd {
    background-color: #69bf4a;
    border-radius: 14px;
    padding: 22px 0;
}
.KnowledgeCenter_glpHeaderText__nRZyH {
    margin: 0;
    color: #fff;
    font-size: 34px;
    text-align: center;
}

.KnowledgeCenter_obesityHeader__bWYNW {
    background-color: #13bfb9;
    border-radius: 14px;
    padding: 22px 0;
}
.KnowledgeCenter_obesityHeaderText__XaFok {
    margin: 0;
    color: #fff;
    font-size: 34px;
    text-align: center;
}

.KnowledgeCenter_obesitySection__rdVYv {
    border: 1px solid #13bfb9;
    border-radius: 14px;
    width: 45%;
}
.KnowledgeCenter_sideEffects__qzcoj {
    font-weight: 700;
    text-align: center;
    padding-left: 1em;
    padding-right: 1em;
}

.KnowledgeCenter_compoundingTitle__o7A8b {
    color: #69bf4a;
    font-weight: 800;
    font-size: 50px;
    text-align: center;
    margin: 60px 0;
}

.KnowledgeCenter_faqSection__z\\+L\\+e {
    color: #69bf4a;
    font-weight: 800;
    font-size: 50px;
    text-align: center;
    margin: 40px 0 0;
}
.KnowledgeCenter_faqQuestions__H1AEB {
    display: flex;
    gap: 11px;
    flex-direction: column;
    margin-top: 2em;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
}
.KnowledgeCenter_faqHeader__fAt-D {
    font-weight: 600;
    text-align: center;
}

.KnowledgeCenter_pharmacies__KuOfC {
    margin: 1em 3em;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
}
.KnowledgeCenter_pharmacyQuestions__3jDdV {
    display: flex;
    gap: 11px;
    flex-direction: column;
    margin-top: 2em;
}

.KnowledgeCenter_researchSection__FIl6f {
    width: 80%;
    margin: 0 auto;
}
.KnowledgeCenter_researchTitle__iEmrt {
    color: #69bf4a;
    font-weight: 800;
    font-size: 50px;
    text-align: center;
    margin: 40px 0 0;
}
.KnowledgeCenter_researchGetStarted__kzVNf {
    color: #69bf4a;
    font-weight: 800;
    font-size: 30px;
    margin: 40px 0 0;
}
.KnowledgeCenter_researchPaper__\\+0UPk {
    font-size: 20px;
    font-weight: 600;
    text-align: start;
    margin-left: 1em;
    margin-right: 1em;
}

.KnowledgeCenter_researchPaper__\\+0UPk a {
    color: #589542;
}
.KnowledgeCenter_semaSection__VV8Vr {
    border: 1px solid #69bf4a;
    border-radius: 14px;
    margin-bottom: 30px;
}
.KnowledgeCenter_semaSection__VV8Vr .KnowledgeCenter_header__lBLlJ {
    background-color: #69bf4a;
    color: #fff;
    text-align: center;
    font-size: 30px;
    border-radius: 14px;
    padding: 13px;
}

.KnowledgeCenter_tirzSection__hbNkD {
    border: 1px solid #13bfb9;
    border-radius: 14px;
    margin-bottom: 30px;
}
.KnowledgeCenter_tirzSection__hbNkD .KnowledgeCenter_header__lBLlJ {
    background-color: #13bfb9;
    color: #fff;
    text-align: center;
    font-size: 30px;
    border-radius: 14px;
    padding: 13px;
}
.KnowledgeCenter_tirzSection__hbNkD .KnowledgeCenter_researchPaper__\\+0UPk a {
    color: #13bfb9;
}


@media screen and (max-width: 1160px) {

    .KnowledgeCenter_webBanner__7YbjW {
        opacity: 30%;
    }
    .KnowledgeCenter_openBox__4MX22, .KnowledgeCenter_closedBox__H0XA1 {
        width: 80%;
    }
}

@media screen and (max-width: 1035px) {
    .KnowledgeCenter_buttonArrow__goD3O {
        height: 50px;
        bottom: -25px;
        z-index: -1;
    }

    .KnowledgeCenter_divider__OvsQD {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        height: 10px;
        border-radius: 0;
    }

    .KnowledgeCenter_webBanner__7YbjW {
        display: none;
    }

    .KnowledgeCenter_bannerText__8qlXG {
        min-width: 0;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }

    .KnowledgeCenter_bannerText__8qlXG {
        min-width: 0;
        margin: 0 auto;
        padding: 0;
        text-align: center;
    }

    .KnowledgeCenter_banner__3hxD0 {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-size: cover;
        background-position: center;
        justify-content: center;
        align-items: bottom;
        height: 160px;
    }

    .KnowledgeCenter_bannerTitle__oYdm3 {
        font-size: 40px;
    }
    .KnowledgeCenter_safetySection__KX4p5 {
        margin: 0 2rem;
    }
    .KnowledgeCenter_safetyTitle__aAr\\+9 {
        font-size: 32px;
    }
    .KnowledgeCenter_safetyItem__cZKSg div {
        font-size: 20px;
    }
    .KnowledgeCenter_safetyButtons__9opkc {
        margin: 2rem;
    }
}

@media screen and (max-width: 768px) {
    .KnowledgeCenter_mainButton__PzZN2 {
        width: 48%;
    }
    .KnowledgeCenter_bannerText__8qlXG h2 {
        font-size: 51px;
        margin: 0px 0px 20px;
    }

    .KnowledgeCenter_safetyTitle__aAr\\+9 {
        font-size: 22px;
    }
    .KnowledgeCenter_buttonText__QkJ-e {
        font-size: 22px;
    }
    .KnowledgeCenter_closedBox__H0XA1 {
        width: 90%;
    }

    .KnowledgeCenter_obesitySection__rdVYv {
        margin: 0 auto;
        width: 100%;
    }

    .KnowledgeCenter_glpSection__X1ghI {
        margin: 0 auto;
        width: 100%;
    }
    .KnowledgeCenter_safetyButtons__9opkc a {
        width: 100%;
        margin-bottom: 20px;
        font-size: 24px;
    }
    .KnowledgeCenter_Safetybtns__6mbMI .KnowledgeCenter_safetyLink__opNOm {
        width: 90%;
    }

    .KnowledgeCenter_glpVsObesity__OwRPU {
        margin: 1em;
        width: auto;
    }
    .KnowledgeCenter_openBox__4MX22{
        width: 90%;
    }
    .KnowledgeCenter_secondDivider__D3-z5{
        width: 99%;
    }
    .KnowledgeCenter_container__-5HE6{
        margin: 25px 0px;
    }
    .KnowledgeCenter_researchSection__FIl6f{
        width: 90%;
    }
    .KnowledgeCenter_researchTitle__iEmrt {
        font-size: 40px;
        margin: 20px 0 0;
    }
    .KnowledgeCenter_safetyTitle__aAr\\+9 {
        font-size: 32px;
    }
    .KnowledgeCenter_safetyTitle__aAr\\+9 img {
        height: 41px;
    }
    .KnowledgeCenter_safetyItem__cZKSg {
        width: 100%;
        margin-bottom: 0.5em;
        justify-content: start;
    }
    .KnowledgeCenter_lastItem__qUC9E {
        justify-content: left;
        margin-bottom: 3em;
    }
    .KnowledgeCenter_safetyItem__cZKSg img {
        height: 31px;
    }
    .KnowledgeCenter_safetyItem__cZKSg div {
        font-size: 16px;
        text-align: left;
    }
}

@media screen and (max-width: 440px) {
    .KnowledgeCenter_banner__3hxD0 {
        height: 120px;
    }
    .KnowledgeCenter_webBanner__7YbjW {
        font-size: 24px;
    }
    .KnowledgeCenter_mainButton__PzZN2 {
        height: 67px;
    }
    .KnowledgeCenter_buttonText__QkJ-e {
        font-size: 18px;
    }
    .KnowledgeCenter_activeButton__Xpz7p {
        height: 60px;
    }
    .KnowledgeCenter_inactiveButton__m5hex {
        height: 40px;
    }
    .KnowledgeCenter_bannerTitle__oYdm3 {
        font-size: 24px;
        padding-bottom: 0.25em;
    }
    .KnowledgeCenter_compoundingTitle__o7A8b {
        font-weight: 800;
        font-size: 30px;
        margin: 60px 0 0;
    }
    .KnowledgeCenter_pharmacies__KuOfC {
        margin: 1em;
        font-size: 16px;
    }
    .KnowledgeCenter_safetyTitle__aAr\\+9 {
        font-size: 24px;
    }
    .KnowledgeCenter_safetyTitle__aAr\\+9 img {
        height: 31px;
    }
    .KnowledgeCenter_safetySection__KX4p5 {
        margin: 0 1rem;
    }
    .KnowledgeCenter_safetyItem__cZKSg img {
        height: 24px;
    }
    .KnowledgeCenter_safetyItem__cZKSg div {
        font-size: 14px;
    }
    .KnowledgeCenter_safetyButtons__9opkc {
        margin: 1rem;
    }
    .KnowledgeCenter_safetyButtons__9opkc a {
        font-size: 18px;
        margin-bottom: 10px;
    }
    .KnowledgeCenter_glpVsObesityTitle__Py3ze {
        font-size: 30px;
    }
    .KnowledgeCenter_realityTitle__-jMYA {
        font-size: 30px;
    }
    .KnowledgeCenter_closedHeader__3ycxb {
        font-size: 20px;
        padding: 15px 15px;
    }
    .KnowledgeCenter_researchSection__FIl6f{
        width: 95%;
    }
    .KnowledgeCenter_researchTitle__iEmrt {
        font-size: 30px;
        margin: 10px 0 0;
    }
    .KnowledgeCenter_researchPaper__\\+0UPk {
        font-size: 16px;
    }
}

@media screen and (max-width:345px) {
    .KnowledgeCenter_buttonText__QkJ-e {
        font-size: 14px;
    }
    .KnowledgeCenter_activeButton__Xpz7p {
        height: 50px;
    }
    .KnowledgeCenter_inactiveButton__m5hex {
        height: 30px;
    }
    .KnowledgeCenter_buttonArrow__goD3O {
        height: 40px;
        bottom: -20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/KnowledgeCenter/KnowledgeCenter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,wCAAwC;IACxC,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;AACA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,cAAc;IACd,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;;AAGA;;IAEI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,WAAW;IACf;;IAEA;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,yDAAwD;QACxD,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,gBAAgB;IACpB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,cAAc;IAClB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".banner {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    background-image: none;\n    position: relative;\n    z-index: -1;\n}\n.container{\n    font-family: 'Aktiv Grotesk', sans-serif;\n    margin: 50px 0px;\n}\n.bannerText {\n    padding: 0 0 0 5%;\n    min-width: 400px;\n}\n.bannerTitle {\n    font-size: 60px;\n    font-family: 'Cocon Bold', sans-serif;\n    padding-bottom: 10px;\n}\n.buttons {\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: space-evenly;\n}\n.inactiveButton {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 30%;\n    z-index: 1;\n    height: 67px;\n    background: transparent;\n    color: rgb(0, 0, 0);\n    border-top: 2px solid;\n    border-right: 2px solid;\n    border-left: 2px solid;\n    border-bottom: none;\n    border-top-left-radius: 2em;\n    border-top-right-radius: 2em;\n}\n.activeButton {\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 30%;\n    z-index: 1;\n    height: 85px;\n    color: #fff;\n    background: #69bf4a;\n    border: 2px solid transparent;\n    border-top-left-radius: 2em;\n    border-top-right-radius: 2em;\n}\n.buttonText {\n    font-weight: 800;\n    font-size: 30px;\n}\n.webBanner {\n    position: relative;\n    right: 0;\n    width: 60%;\n}\n.divider {\n    height: 22px;\n    width: 90%;\n    margin-left: 90px;\n    margin-right: 90px;\n    background-color: #69bf4a;\n    position: absolute;\n    bottom: -11px;\n    border-radius: 999px;\n}\n.buttonArrow {\n    position: absolute;\n    bottom: -30px;\n    height: 60px;\n    z-index: -1;\n}\n\n.secondDivider {\n    height: 11px;\n    position: relative;\n    top: -10px;\n    margin: 0 auto;\n    display: block;\n    width: 77%;\n\n}\n\n.safetyTitle {\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 50px;\n    margin: 1em auto;\n}\n.safetyTitle img {\n    margin-right: 0.5em;\n}\n.safetySection {\n    margin: 0 5rem;\n    text-align: center;\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.safetyItem {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: calc(50% - 10px);\n    margin-bottom: 20px;\n    gap: 10px;\n}\n.safetyItem div {\n    font-size: 24px;\n    font-weight: 700;\n    text-align: left;\n}\n.safetyItem img {\n    height: 51px;\n}\n.lastItem {\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 3em;\n}\n.safetyButtons {\n    margin: 5rem;\n    text-align: center;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.safetyButtons a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(50% - 2em);\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: 700;\n    background-color: #13bfb9;\n    color: #fff;\n    border-radius: 999px;\n    text-decoration: none;\n    padding: 0.5em;\n}\n.safetyButtons a:hover {\n    background-color: #69bf4a;\n}\n\n\n.mythVsReality {\n    display: flex;\n    gap: 11px;\n    flex-direction: column;\n}\n.realityTitle {\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 50px;\n    text-align: center;\n}\n.closedBox {\n    border: 1px solid #69bf4a;\n    width: 60%;\n    border-radius: 14px;\n    margin: 0 auto;\n}\n.openBox {\n    border: 1px solid #000;\n    width: 60%;\n    border-radius: 14px;\n    margin: 0 auto;\n}\n.openHeader {\n    background-color: #69bf4a;\n    border-radius: 13px;\n    font-size: 24px;\n    padding: 20px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.openHeaderText {\n    color: #000;\n    font-weight: 700;\n}\n.openHeaderMyth {\n    margin: 0;\n    color: #fff;\n    font-weight: 700;\n}\n.closedHeader {\n    background-color: #fff;\n    border-radius: 13px;\n    font-size: 24px;\n    padding: 20px 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #000;\n}\n.closedHeaderText {\n    color: #000;\n    font-weight: 700;\n}\n.closedHeaderMyth {\n    color: #13bfb9;\n    font-weight: 700;\n}\n.questionBody {\n    padding: 22px;\n    margin: 0;\n    font-size: 18px;\n    line-height: 1.5;\n    letter-spacing: 1px;\n}\n\n.glpVsObesity {\n    margin: 0 auto;\n    width: 80%;\n}\n.glp1s {\n    color: #69bf4a;\n}\n.obesity {\n    color: #13bfb9;\n}\n.glpVsObesityTitle {\n    color: #000;\n    font-weight: 800;\n    font-size: 50px;\n    text-align: center;\n    margin: 40px 0 0;\n}\n.glpVsObesityHeader {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 600;\n}\n.glpVsObesitySection {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2em;\n    gap: 11px;\n}\n\n.glpSection {\n    border: 1px solid #69bf4a;\n    border-radius: 14px;\n    width: 45%;\n}\n\n.glpHeader {\n    background-color: #69bf4a;\n    border-radius: 14px;\n    padding: 22px 0;\n}\n.glpHeaderText {\n    margin: 0;\n    color: #fff;\n    font-size: 34px;\n    text-align: center;\n}\n\n.obesityHeader {\n    background-color: #13bfb9;\n    border-radius: 14px;\n    padding: 22px 0;\n}\n.obesityHeaderText {\n    margin: 0;\n    color: #fff;\n    font-size: 34px;\n    text-align: center;\n}\n\n.obesitySection {\n    border: 1px solid #13bfb9;\n    border-radius: 14px;\n    width: 45%;\n}\n.sideEffects {\n    font-weight: 700;\n    text-align: center;\n    padding-left: 1em;\n    padding-right: 1em;\n}\n\n.compoundingTitle {\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 50px;\n    text-align: center;\n    margin: 60px 0;\n}\n\n.faqSection {\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 50px;\n    text-align: center;\n    margin: 40px 0 0;\n}\n.faqQuestions {\n    display: flex;\n    gap: 11px;\n    flex-direction: column;\n    margin-top: 2em;\n    font-size: 20px;\n    font-weight: 400;\n    text-align: center;\n}\n.faqHeader {\n    font-weight: 600;\n    text-align: center;\n}\n\n.pharmacies {\n    margin: 1em 3em;\n    font-weight: 700;\n    font-size: 18px;\n    text-align: center;\n}\n.pharmacyQuestions {\n    display: flex;\n    gap: 11px;\n    flex-direction: column;\n    margin-top: 2em;\n}\n\n.researchSection {\n    width: 80%;\n    margin: 0 auto;\n}\n.researchTitle {\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 50px;\n    text-align: center;\n    margin: 40px 0 0;\n}\n.researchGetStarted {\n    color: #69bf4a;\n    font-weight: 800;\n    font-size: 30px;\n    margin: 40px 0 0;\n}\n.researchPaper {\n    font-size: 20px;\n    font-weight: 600;\n    text-align: start;\n    margin-left: 1em;\n    margin-right: 1em;\n}\n\n.researchPaper a {\n    color: #589542;\n}\n.semaSection {\n    border: 1px solid #69bf4a;\n    border-radius: 14px;\n    margin-bottom: 30px;\n}\n.semaSection .header {\n    background-color: #69bf4a;\n    color: #fff;\n    text-align: center;\n    font-size: 30px;\n    border-radius: 14px;\n    padding: 13px;\n}\n\n.tirzSection {\n    border: 1px solid #13bfb9;\n    border-radius: 14px;\n    margin-bottom: 30px;\n}\n.tirzSection .header {\n    background-color: #13bfb9;\n    color: #fff;\n    text-align: center;\n    font-size: 30px;\n    border-radius: 14px;\n    padding: 13px;\n}\n.tirzSection .researchPaper a {\n    color: #13bfb9;\n}\n\n\n@media screen and (max-width: 1160px) {\n\n    .webBanner {\n        opacity: 30%;\n    }\n    .openBox, .closedBox {\n        width: 80%;\n    }\n}\n\n@media screen and (max-width: 1035px) {\n    .buttonArrow {\n        height: 50px;\n        bottom: -25px;\n        z-index: -1;\n    }\n\n    .divider {\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n        height: 10px;\n        border-radius: 0;\n    }\n\n    .webBanner {\n        display: none;\n    }\n\n    .bannerText {\n        min-width: 0;\n        margin: 0 auto;\n        padding: 0;\n        text-align: center;\n    }\n\n    .bannerText {\n        min-width: 0;\n        margin: 0 auto;\n        padding: 0;\n        text-align: center;\n    }\n\n    .banner {\n        background-image: url(../../assets/program-banner-2.png);\n        background-size: cover;\n        background-position: center;\n        justify-content: center;\n        align-items: bottom;\n        height: 160px;\n    }\n\n    .bannerTitle {\n        font-size: 40px;\n    }\n    .safetySection {\n        margin: 0 2rem;\n    }\n    .safetyTitle {\n        font-size: 32px;\n    }\n    .safetyItem div {\n        font-size: 20px;\n    }\n    .safetyButtons {\n        margin: 2rem;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .mainButton {\n        width: 48%;\n    }\n    .bannerText h2 {\n        font-size: 51px;\n        margin: 0px 0px 20px;\n    }\n\n    .safetyTitle {\n        font-size: 22px;\n    }\n    .buttonText {\n        font-size: 22px;\n    }\n    .closedBox {\n        width: 90%;\n    }\n\n    .obesitySection {\n        margin: 0 auto;\n        width: 100%;\n    }\n\n    .glpSection {\n        margin: 0 auto;\n        width: 100%;\n    }\n    .safetyButtons a {\n        width: 100%;\n        margin-bottom: 20px;\n        font-size: 24px;\n    }\n    .Safetybtns .safetyLink {\n        width: 90%;\n    }\n\n    .glpVsObesity {\n        margin: 1em;\n        width: auto;\n    }\n    .openBox{\n        width: 90%;\n    }\n    .secondDivider{\n        width: 99%;\n    }\n    .container{\n        margin: 25px 0px;\n    }\n    .researchSection{\n        width: 90%;\n    }\n    .researchTitle {\n        font-size: 40px;\n        margin: 20px 0 0;\n    }\n    .safetyTitle {\n        font-size: 32px;\n    }\n    .safetyTitle img {\n        height: 41px;\n    }\n    .safetyItem {\n        width: 100%;\n        margin-bottom: 0.5em;\n        justify-content: start;\n    }\n    .lastItem {\n        justify-content: left;\n        margin-bottom: 3em;\n    }\n    .safetyItem img {\n        height: 31px;\n    }\n    .safetyItem div {\n        font-size: 16px;\n        text-align: left;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .banner {\n        height: 120px;\n    }\n    .webBanner {\n        font-size: 24px;\n    }\n    .mainButton {\n        height: 67px;\n    }\n    .buttonText {\n        font-size: 18px;\n    }\n    .activeButton {\n        height: 60px;\n    }\n    .inactiveButton {\n        height: 40px;\n    }\n    .bannerTitle {\n        font-size: 24px;\n        padding-bottom: 0.25em;\n    }\n    .compoundingTitle {\n        font-weight: 800;\n        font-size: 30px;\n        margin: 60px 0 0;\n    }\n    .pharmacies {\n        margin: 1em;\n        font-size: 16px;\n    }\n    .safetyTitle {\n        font-size: 24px;\n    }\n    .safetyTitle img {\n        height: 31px;\n    }\n    .safetySection {\n        margin: 0 1rem;\n    }\n    .safetyItem img {\n        height: 24px;\n    }\n    .safetyItem div {\n        font-size: 14px;\n    }\n    .safetyButtons {\n        margin: 1rem;\n    }\n    .safetyButtons a {\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n    .glpVsObesityTitle {\n        font-size: 30px;\n    }\n    .realityTitle {\n        font-size: 30px;\n    }\n    .closedHeader {\n        font-size: 20px;\n        padding: 15px 15px;\n    }\n    .researchSection{\n        width: 95%;\n    }\n    .researchTitle {\n        font-size: 30px;\n        margin: 10px 0 0;\n    }\n    .researchPaper {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width:345px) {\n    .buttonText {\n        font-size: 14px;\n    }\n    .activeButton {\n        height: 50px;\n    }\n    .inactiveButton {\n        height: 30px;\n    }\n    .buttonArrow {\n        height: 40px;\n        bottom: -20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `KnowledgeCenter_banner__3hxD0`,
	"container": `KnowledgeCenter_container__-5HE6`,
	"bannerText": `KnowledgeCenter_bannerText__8qlXG`,
	"bannerTitle": `KnowledgeCenter_bannerTitle__oYdm3`,
	"buttons": `KnowledgeCenter_buttons__YR49s`,
	"inactiveButton": `KnowledgeCenter_inactiveButton__m5hex`,
	"activeButton": `KnowledgeCenter_activeButton__Xpz7p`,
	"buttonText": `KnowledgeCenter_buttonText__QkJ-e`,
	"webBanner": `KnowledgeCenter_webBanner__7YbjW`,
	"divider": `KnowledgeCenter_divider__OvsQD`,
	"buttonArrow": `KnowledgeCenter_buttonArrow__goD3O`,
	"secondDivider": `KnowledgeCenter_secondDivider__D3-z5`,
	"safetyTitle": `KnowledgeCenter_safetyTitle__aAr+9`,
	"safetySection": `KnowledgeCenter_safetySection__KX4p5`,
	"safetyItem": `KnowledgeCenter_safetyItem__cZKSg`,
	"lastItem": `KnowledgeCenter_lastItem__qUC9E`,
	"safetyButtons": `KnowledgeCenter_safetyButtons__9opkc`,
	"mythVsReality": `KnowledgeCenter_mythVsReality__ESCgl`,
	"realityTitle": `KnowledgeCenter_realityTitle__-jMYA`,
	"closedBox": `KnowledgeCenter_closedBox__H0XA1`,
	"openBox": `KnowledgeCenter_openBox__4MX22`,
	"openHeader": `KnowledgeCenter_openHeader__skNOu`,
	"openHeaderText": `KnowledgeCenter_openHeaderText__faTyb`,
	"openHeaderMyth": `KnowledgeCenter_openHeaderMyth__+byQP`,
	"closedHeader": `KnowledgeCenter_closedHeader__3ycxb`,
	"closedHeaderText": `KnowledgeCenter_closedHeaderText__sKIGd`,
	"closedHeaderMyth": `KnowledgeCenter_closedHeaderMyth__Nz27-`,
	"questionBody": `KnowledgeCenter_questionBody__0gOf7`,
	"glpVsObesity": `KnowledgeCenter_glpVsObesity__OwRPU`,
	"glp1s": `KnowledgeCenter_glp1s__1vIMw`,
	"obesity": `KnowledgeCenter_obesity__J+Ht3`,
	"glpVsObesityTitle": `KnowledgeCenter_glpVsObesityTitle__Py3ze`,
	"glpVsObesityHeader": `KnowledgeCenter_glpVsObesityHeader__WZHsH`,
	"glpVsObesitySection": `KnowledgeCenter_glpVsObesitySection__vpFBi`,
	"glpSection": `KnowledgeCenter_glpSection__X1ghI`,
	"glpHeader": `KnowledgeCenter_glpHeader__XhZLd`,
	"glpHeaderText": `KnowledgeCenter_glpHeaderText__nRZyH`,
	"obesityHeader": `KnowledgeCenter_obesityHeader__bWYNW`,
	"obesityHeaderText": `KnowledgeCenter_obesityHeaderText__XaFok`,
	"obesitySection": `KnowledgeCenter_obesitySection__rdVYv`,
	"sideEffects": `KnowledgeCenter_sideEffects__qzcoj`,
	"compoundingTitle": `KnowledgeCenter_compoundingTitle__o7A8b`,
	"faqSection": `KnowledgeCenter_faqSection__z+L+e`,
	"faqQuestions": `KnowledgeCenter_faqQuestions__H1AEB`,
	"faqHeader": `KnowledgeCenter_faqHeader__fAt-D`,
	"pharmacies": `KnowledgeCenter_pharmacies__KuOfC`,
	"pharmacyQuestions": `KnowledgeCenter_pharmacyQuestions__3jDdV`,
	"researchSection": `KnowledgeCenter_researchSection__FIl6f`,
	"researchTitle": `KnowledgeCenter_researchTitle__iEmrt`,
	"researchGetStarted": `KnowledgeCenter_researchGetStarted__kzVNf`,
	"researchPaper": `KnowledgeCenter_researchPaper__+0UPk`,
	"semaSection": `KnowledgeCenter_semaSection__VV8Vr`,
	"header": `KnowledgeCenter_header__lBLlJ`,
	"tirzSection": `KnowledgeCenter_tirzSection__hbNkD`,
	"mainButton": `KnowledgeCenter_mainButton__PzZN2`,
	"Safetybtns": `KnowledgeCenter_Safetybtns__6mbMI`,
	"safetyLink": `KnowledgeCenter_safetyLink__opNOm`
};
export default ___CSS_LOADER_EXPORT___;
